import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import PhysicianProfileSidebar from "../Components/PhysicianProfileSidebar";
import { useSelector } from "react-redux";
import Norecord from "../Components/Norecord";
import Pagination from "../Components/Pagination";
import {
	getPhysicianappointmentclosesapi,
	getPhysicianappointmentsapi,
} from "../network/Network";
import Swal from "sweetalert2";

const PhysicianMyConsultations = () => {
	const [loading, setLoading] = useState(false);
	const token = useSelector((state) => state?.Auth?.token);
	const [clickedButton, setClickedButton] = useState("upcoming");
	const [appointmentsCache, setAppointmentsCache] = useState({
		upcoming: null,
		current: null,
		past: null,
	});
	const [currentAppointments, setCurrentAppointments] = useState([]);
	const [current_page, setCurrent_page] = useState(1);
	const [pageCount, setPageCount] = useState();

	// Button Handler
	const handleClick = (buttonName) => {
		setClickedButton(buttonName);
		setCurrent_page(1);
	};

	// Fetch Appointments API
	useEffect(() => {
		if (appointmentsCache[clickedButton]) {
			setCurrentAppointments(appointmentsCache[clickedButton].data);
			setPageCount(appointmentsCache[clickedButton].pageCount);
			return;
		}

		getPhysicianappointmentsapi(clickedButton, token, current_page).then(
			(res) => {
				const fetchedData = res?.data?.data || [];
				const total = res?.data?.total || 0;
				const limit = res?.data?.per_page || 1;
				const totalPageCount = Math.ceil(total / limit);

				// Update the cache
				setAppointmentsCache((prevCache) => ({
					...prevCache,
					[clickedButton]: { data: fetchedData, pageCount: totalPageCount },
				}));

				// Update the current state
				setCurrentAppointments(fetchedData);
				setPageCount(totalPageCount);
			},
		);
	}, [clickedButton, current_page]);

	const HandleClose = (e, id) => {
		e.preventDefault();
		setLoading(true);
		getPhysicianappointmentclosesapi(token, id, current_page)
			.then((res) => {
				Swal.fire({
					position: "center",
					icon: "success",
					text: res?.data?.message || "Session ended successfully",
					showConfirmButton: false,
					timer: 1500,
				});

				// ✅ After closing, re-fetch appointments
				getPhysicianappointmentsapi(clickedButton, token, current_page).then(
					(res) => {
						const fetchedData = res?.data?.data || [];
						const total = res?.data?.total || 0;
						const limit = res?.data?.per_page || 1;
						const totalPageCount = Math.ceil(total / limit);

						// Update cache
						setAppointmentsCache((prevCache) => ({
							...prevCache,
							[clickedButton]: { data: fetchedData, pageCount: totalPageCount },
						}));

						// Update UI state
						setCurrentAppointments(fetchedData);
						setPageCount(totalPageCount);
						setLoading(false);
					},
				);
			})
			.catch((err) => {
				setLoading(false);
				const errorData = err?.response?.data?.errors?.error;

				if (errorData) {
					if (Array.isArray(errorData)) {
						errorData.forEach((msg) =>
							Swal.fire({
								position: "center",
								icon: "error",
								text: msg,
								showConfirmButton: false,
								timer: 2200,
							}),
						);
					} else if (typeof errorData === "string") {
						Swal.fire({
							position: "center",
							icon: "error",
							text: errorData,
							showConfirmButton: false,
							timer: 2200,
						});
					} else if (typeof errorData === "object") {
						Object.values(errorData).forEach((msg) =>
							Swal.fire({
								position: "center",
								icon: "error",
								text: msg,
								showConfirmButton: false,
								timer: 2200,
							}),
						);
					}
				}
			});
	};

	return (
		<>
			<Header />
			<PageHeader pagename="Physician Profile" />
			<section className="main-sidebar user-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<PhysicianProfileSidebar />
						</div>
						<div className="col-lg-8">
							<div className="main-profile-content radius-20 p-4 patient-appointment_dv">
								<div className="main-headind wrapper-d-fff d-flex align-items-center 	 mb-3  justify-content-between w-100">
									<div className="d-flex gap-2 align-items-center">
										<div className="edit-btn back">
											<div className="nav-anchor">
												<i className="fa-solid fa-arrow-left"></i>
											</div>
										</div>
										<div>
											<h5 className="main-heading level-6 ps-2 main-heading-font dark-color mb-0 wow animate__animated            animate__zoomIn animate__delay-1s ">
												My Consultations
											</h5>
										</div>
									</div>
									<div className="">
										<div className="btn_consultation">
											<button
												className={
													clickedButton === "upcoming" ? "active_btn" : ""
												}
												onClick={() => handleClick("upcoming")}
											>
												Upcoming
											</button>
											<button
												className={
													clickedButton === "current" ? "active_btn" : ""
												}
												onClick={() => handleClick("current")}
											>
												Current
											</button>
											<button
												className={clickedButton === "past" ? "active_btn" : ""}
												onClick={() => handleClick("past")}
											>
												Past
											</button>
										</div>
									</div>
								</div>
								<div className="row">
									{currentAppointments?.length > 0 ? (
										currentAppointments.map((data, gindex) => (
											<div className="col-lg-6 col-md-6 mt-4" key={gindex}>
												{console.log(data, "sdakd")}
												<div
													className={
														clickedButton === "current"
															? "dark-bg doctor-detail-des main-profile-content radius-35 padding-profile"
															: "doctor-detail-des main-profile-content radius-20 p-4"
													}
												>
													{/* <div className="d-flex align-items-center gap-3 mb-2">
														<img
															src={data?.patient_profile_image_url}
															className="img-fluid profie_img"
															alt=""
														/>
														<div>
															<h4
																className={
																	clickedButton === "current"
																		? "main-heading-font text-white mb-0"
																		: "main-heading-font dark-color mb-0"
																}
															>
																{data?.patient_title}
															</h4>
															<h5 className="mb-0 extra-color-9">
																{data?.physician_degree_title}
															</h5>
														</div>
													</div> */}
													<div className="d-flex justify-content-between align-items-center gap-3 mb-2">
														<div className="d-flex align-items-center gap-3">
															<img
																src={data?.patient_profile_image_url}
																className="img-fluid profie_img"
																alt=""
																style={{
																	width: "50px",
																	height: "50px",
																	borderRadius: "50%",
																	objectFit: "cover",
																}}
															/>
															<div>
																<h4
																	className={
																		clickedButton === "current"
																			? "main-heading-font text-white mb-0"
																			: "main-heading-font dark-color mb-0"
																	}
																>
																	{data?.patient_title}
																</h4>
																<h5 className="mb-0 extra-color-9">
																	{data?.physician_degree_title}
																</h5>
															</div>
														</div>
														{clickedButton === "current" && (
															<button
																className="btn btn-primary btn-sm text-white"
																style={{
																	backgroundColor: "#007bff",
																	borderRadius: "8px",
																	fontSize: "13px",
																	fontWeight: "500",
																	padding: "5px 12px",
																	boxShadow: "0 2px 6px rgba(0, 123, 255, 0.4)",
																	transition: "0.3s",
																}}
																onMouseOver={(e) =>
																	(e.currentTarget.style.backgroundColor =
																		"#0056b3")
																}
																onMouseOut={(e) =>
																	(e.currentTarget.style.backgroundColor =
																		"#007bff")
																}
																onClick={(e) =>
																	HandleClose(e, data?.booking_id)
																}
															>
																{loading ? "Ending..." : "End Session"}
															</button>
														)}
													</div>

													<div className="mt-4">
														<Link
															className={
																clickedButton === "current"
																	? "detail-physician-btn d-flex align-items-center justoify-content-center w-100 text-white extra-bg-16"
																	: "detail-physician-btn"
															}
															to={`/physician-consultation-detail/${data?.booking_id}`}
															state={{
																current_page: current_page,
																tabName: clickedButton,
															}}
														>
															<span>
																<i className="fa-regular fa-calendar"></i>
															</span>
															{data?.booking_day}
															{data?.booking_date} -{data?.booking_time}
														</Link>
													</div>
												</div>
											</div>
										))
									) : (
										<Norecord />
									)}
								</div>
								<Pagination
									pageCount={pageCount}
									setPageCount={setPageCount}
									current_page={current_page}
									setCurrent_page={setCurrent_page}
									apicall={currentAppointments}
								/>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default PhysicianMyConsultations;
